var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox exchange-config-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "page-title" }, [_vm._v("积分兑换配置")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-wrap" },
            [
              _c("el-input", {
                staticClass: "keyword-input",
                attrs: {
                  placeholder: "请输入活动名称/活动id",
                  size: "small",
                  clearable: "",
                  "prefix-icon": "el-icon-search",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearch($event)
                  },
                },
                model: {
                  value: _vm.query.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "keyword", $$v)
                  },
                  expression: "query.keyword",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("活动状态:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "select-box",
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "全部",
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "全部", value: "" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "未开始", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "进行中", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "已结束", value: 2 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("排序:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "sort-box",
                      attrs: { size: "small" },
                      model: {
                        value: _vm.query.sort,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "sort", $$v)
                        },
                        expression: "query.sort",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "按更新时间降序排列",
                          value: "update_desc",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          label: "按更新时间升序排列",
                          value: "update_asc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "reset-btn",
                  attrs: { type: "danger", size: "small" },
                  on: { click: _vm.handleReset },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tool-wrap" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: [
                        "admin:shopintegral:activity:addExchangeActivity",
                      ],
                      expression:
                        "['admin:shopintegral:activity:addExchangeActivity']",
                    },
                  ],
                  attrs: { type: "primary", plain: "", size: "mini" },
                  on: { click: _vm.handleCreate },
                },
                [_vm._v("添加积分兑换配置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "exchange-table",
              attrs: { data: _vm.tableData, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "活动id", "min-width": "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "活动名称",
                  "min-width": "140",
                  "class-name": "points-activity-name-col",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              effect: "dark",
                              "popper-class": "points-integral-col-tooltip",
                              "open-delay": 300,
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v(_vm._s(scope.row.activityName || "—"))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "points-integral-col-ellipsis" },
                              [_vm._v(_vm._s(scope.row.activityName || "—"))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品类型", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.productTypeLabel(scope.row.productType)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "兑换积分规则", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              effect: "dark",
                              "popper-class": "points-integral-col-tooltip",
                              "open-delay": 300,
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v(_vm._s(scope.row.ruleDesc || "—"))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "points-integral-col-ellipsis" },
                              [_vm._v(_vm._s(scope.row.ruleDesc || "—"))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "适用分销客户", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              effect: "dark",
                              "popper-class": "points-integral-col-tooltip",
                              "open-delay": 300,
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  _vm._s(scope.row.applyCustomerDesc || "—")
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "points-integral-col-ellipsis" },
                              [
                                _vm._v(
                                  _vm._s(scope.row.applyCustomerDesc || "—")
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "活动时间", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatActivityRange(scope.row)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusDesc",
                  label: "活动状态",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "340", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.isEndedActivity(scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:shopintegral:activity:info"],
                                    expression:
                                      "['admin:shopintegral:activity:info']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            查看\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:shopintegral:activity:addExchangeActivity",
                                ],
                                expression:
                                  "['admin:shopintegral:activity:addExchangeActivity']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopy(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                        _vm._v(" "),
                        !_vm.isEndedActivity(scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:shopintegral:activity:updateExchangeActivity",
                                    ],
                                    expression:
                                      "['admin:shopintegral:activity:updateExchangeActivity']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            编辑\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:shopintegral:activity:product:page",
                                ],
                                expression:
                                  "['admin:shopintegral:activity:product:page']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openGoodsManage(scope.row)
                              },
                            },
                          },
                          [_vm._v("商品管理")]
                        ),
                        _vm._v(" "),
                        _vm.isNotStartedActivity(scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:shopintegral:activity:delete",
                                    ],
                                    expression:
                                      "['admin:shopintegral:activity:delete']",
                                  },
                                ],
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            删除\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isOngoingActivity(scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:shopintegral:activity:end"],
                                    expression:
                                      "['admin:shopintegral:activity:end']",
                                  },
                                ],
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleFinish(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            结束\n          ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("template", { slot: "empty" }, [
                _vm.showAddEmptyBlock
                  ? _c(
                      "div",
                      { staticClass: "empty-wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-shopping-bag-2 empty-icon",
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:shopintegral:activity:addExchangeActivity",
                                ],
                                expression:
                                  "['admin:shopintegral:activity:addExchangeActivity']",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.handleCreate },
                          },
                          [_vm._v("去添加")]
                        ),
                      ],
                      1
                    )
                  : _c("span", { staticClass: "el-table__empty-text" }, [
                      _vm._v("暂无数据"),
                    ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageData.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageData.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }